// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#4D4D4D","menuActiveText":"#fff","subMenuActiveText":"#595959","menuBg":"#fff","menuHover":"#FAFAFA","subMenuBg":"#fff","subMenuHover":"#FAFAFA","sideBarWidth":"219px"};